import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { filter, map } from 'rxjs';
import { KundenportalUpdateDialogComponent } from './core/config/kundenportal-update-dialog/kundenportal-update-dialog.component';
import { KundenportalVersionService } from './core/config/kundenportal-version.service';
import { DevLoginExpiryService } from './core/auth/dev-login-expiry.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, TranslocoPipe, KundenportalUpdateDialogComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly kundenportalVersion = inject(KundenportalVersionService);

  /** A developer is signed in as this person (bpp-auth dashboard dev login). */
  protected readonly isDevSession: Signal<boolean> = inject(DevLoginExpiryService).isDevSession;

  /** A slim top progress bar for lazy-route loads (BRO-1171) — the shell has no other loading cue. */
  protected readonly isNavigating: Signal<boolean> = toSignal(
    this.router.events.pipe(
      filter(
        (event) =>
          event instanceof NavigationStart ||
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
      ),
      map((event) => event instanceof NavigationStart)
    ),
    { initialValue: false }
  );

  /** Gates the `@defer` around the update dialog, so PrimeNG's dialog stays out of the initial chunk. */
  protected readonly hasPendingUpdate: Signal<boolean> = computed(() => this.kundenportalVersion.pendingUpdate() !== null);
}
